<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "PublicationName",
  extends: UrlElement,
  mixins: [StoryPageElementMixin],
  elementPanelSettings: {
    displayName: "Publication Name",
    displayIcon: "text-alt",
  },
  computed: {
    label() {
      return this.entity.publishingPlatformName;
    },
    computedHref() {
      return `${this.links.web}/story/${this.entity.storyId}`;
    },
  },
};
</script>
